import { createSharedPathnamesNavigation } from 'next-intl/navigation';
import { locales } from './config';

// Re-exportar locales desde la configuración centralizada
export { locales };
export const { Link, redirect, usePathname, useRouter } = createSharedPathnamesNavigation({ locales });
